import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Text, Flex, Image } from "@chakra-ui/react";

const TemplateItem = ({ properties, useTemplateHandler, previewHandler }) => {
  const { imageUrl, id, description, title } = properties;
  return (
    <Box
      h="360px"
      w="448px"
      borderWidth="1px"
      borderRadius="4px"
      overflow="hidden"
      padding="16px"
      marginLeft="16px"
      marginBottom="16px"
    >
      <Box bg="#fff">
        {/* <TemplateImage /> */}
        <Image src={imageUrl} h="200px" w="416px" alt={title} />
        {/* <TemplateBody /> */}
        <Box>
          <Box
            // mt="1"
            fontWeight="semibold"
            //as="h4"
            fontSize="14px"
            lineHeight="tight"
            paddingTop="12px"
            paddingBottom="12px"
          >
            {title}
          </Box>
          <Text fontSize="14px" color="#475867">
            {description}
          </Text>
        </Box>
        {/* controls */}
        <Box mt="12px" mb="16px">
          <Flex justify="flex-start">
            {id != "blank_template" && (
              <Button
                mr="2"
                colorScheme="secondary"
                className="btn--secondary"
                w="79px"
                h="32px"
                marginRight="12px"
                onClick={(e) => previewHandler(e, id)}
              >
                Preview
              </Button>
            )}

            <Button
              colorScheme="primary"
              className="btn--primary"
              w="116px"
              h="32px"
              onClick={(e) => useTemplateHandler(e, id)}
            >
              Use Template
            </Button>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

TemplateItem.propTypes = {
  properties: PropTypes.object.isRequired,
  useTemplateHandler: PropTypes.func.isRequired,
  previewHandler: PropTypes.func.isRequired,
};

export default TemplateItem;
